
import { defineComponent, ref, reactive } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";
import { errManager, showNotification } from "@/core/config/Tools";
//services
import personService from '@/core/services/PersonService';
import RepmanService from '@/core/services/RepmanService';
import GlobalService from '@/core/services/GlobalService';
//components
import AddEditFunction from '@/views/functions/modals/AddEdit.vue'

export default defineComponent({
    props:{
        idinstitution: {
            type: null,
            required: false,
            default: () => ({})
        }
    },
    components: {
        AddEditFunction
    },
    emits: ["onResponse"],
    setup(props, { emit }) {
        const store = useStore();
        const loading = ref(false);
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const AddEditFunctionRef = ref<any>(null);

        const form = reactive<any>({});
        const ruleFormRef = ref<FormInstance>();
        const rules = reactive<FormRules>({});
        const listPeople = ref<any>([]);
        const listFunctions = ref<any>([]);

        const openModal = () => {
            isModalVisible.value = true
        };

        const onOpen = () => {
            titleDialog.value = 'Registrar representante'
            getListFunctions()
        };

        const onClosed = () => {
            resetForm(ruleFormRef.value)
            Object.keys(form).forEach(key => delete form[key]);
        };

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const remoteMethod = async (query: string) => {
            if (query.trim()) {
                loading.value = true
                await personService.postOptions('search', {search: query.toLowerCase()})
                .then((res)=>{
                    listPeople.value = res.data
                    loading.value = false
                }).catch(({response})=>{
                    loading.value = false
                    errManager(response)
                })
            } else {
                listPeople.value = []
            }
        };

        const getListFunctions = async () => {
            loading.value = true;
            await GlobalService.get('api', 'functions?modality=select')
            .then((res)=>{
                listFunctions.value = res.data
                loading.value = false
            }).catch(({response})=>{
                loading.value = false
                errManager(response)
            })
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid) => {
                if (valid)
                    save()

            });
        };

        const save = async () => {
            loading.value = true
            form.idinstitution = props.idinstitution
            await RepmanService.postOptions('save', form)
                .then((res) => {
                    loading.value = false
                    showNotification(res.data)
                    if(res.data.status == 'success') {
                        isModalVisible.value = false
                        emit("onResponse", res.data)
                    }
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        };

        const openAddFunction = () => {
            if(AddEditFunctionRef.value){
                AddEditFunctionRef.value.openModal();
            }
        };

        const onResponseFunction = (data: any) => {
            if (!data) return;
            if(data.status == 'success') getListFunctions()
        };


        return {
            loading,
            titleDialog,
            isModalVisible,
            AddEditFunctionRef,
            form,
            rules,
            ruleFormRef,
            listPeople,
            listFunctions,
            //event
            onOpen,
            onClosed,
            openModal,
            remoteMethod,
            getListFunctions,
            submitForm,
            openAddFunction,
            onResponseFunction
        }
    },
})
